export const CreditCardPickerComponent = {
    template: `
    <ul>
        <li ng-repeat="card in $ctrl.accountService.data.cards">
            <label>
                <input
                    type="radio"
                    ng-model="$ctrl.paymentService.data.tempPayment.guid"
                    ng-value="card.guid"
                    ng-change="$ctrl.selectCreditCard(card)">
                <credit-card-card card="card"></credit-card-card>
            </label>
        </li>
        <li ng-if="$ctrl.addCardRadioVisible()">
            <label>
                <input
                    type="radio"
                    ng-change="$ctrl.clearPayment()"
                    ng-model="$ctrl.paymentService.data.tempPayment.guid"
                    ng-value="null"
                    name="creditChoice"/> New Card
            </label>
        </li>
        <add-credit-card save="optional" ng-if="$ctrl.addCardVisible()"></add-credit-card>
        <footer ng-if="$ctrl.hasMaxCards()">
            <p c-type="body-sm-primary italic center">{{$ctrl.disclaimerText}}</p>
        </footer>
    </ul>
    `,
    controller: class {
        constructor(accountService, paymentService) {
            'ngInject';
            this.accountService = accountService;
            this.paymentService = paymentService;
            this.selectedCard = null;
            this.maxCardsLimit = 3;
            this.disclaimerText = `You have reached the limit of ${this.maxCardsLimit} saved cards`;
        }

        $onInit() {
            this.accountService.getCards();
        }

        selectCreditCard(card) {
            this.paymentService.setTempCreditCardPayment(card);
        }

        clearPayment() {
            this.paymentService.clearTempCreditCardPayment();
        }

        addCardRadioVisible() {
            const hasZeroCards = this.accountService.data.cards.length === 0;
            return !(hasZeroCards || this.hasMaxCards());
        }

        hasMaxCards() {
            return this.accountService.data.cards.length >= this.maxCardsLimit;
        }

        addCardVisible() {
            return !(this.paymentService.data.tempPayment.guid || this.hasMaxCards());
        }
    }
};
